export default "__VITE_ASSET__Ccnv8XKp__"